import { InstrumentModelNameEnum } from './InstrumentFacade';
import ptc48Icon from '../assets/ptc-tempo-48-48-icon-no-badge.svg';
import ptcIcon from '../assets/ptc-tempo-icon-no-badge.svg';

// eslint-disable-next-line import/prefer-default-export
export function getInstrumentIcon(instrumentType: string) {
  if (instrumentType === InstrumentModelNameEnum.PTCTempo4848) return ptc48Icon;
  return ptcIcon;
}
